import React, {useMemo} from 'react';
import ReactApexChart from 'react-apexcharts';
import {Loader} from 'components';
import {getPeriod} from 'routes/FraudDetection/Reconciliation/constants';
import {processBAASData} from 'routes/Verifications/utils';
import {shortenLargeNumbers} from 'helpers/shortenLargeNumbers';

const OverviewChart = ({data = [], periodType, loading}) => {
  const sortedData = data?.sort((a, b) => new Date(a.date) - new Date(b.date));

  const chartData = processBAASData(sortedData);

  const series = useMemo(
    () => [
      {
        name: 'Inflow',
        data: chartData.map(d => d.inFlow),
      },
      {
        name: 'Outflow',
        data: chartData.map(d => d.outFlow),
      },
    ],
    [chartData],
  );

  const categories = useMemo(
    () => chartData.map(d => getPeriod(d?.date, periodType)),
    [chartData, periodType],
  );

  const options = {
    chart: {
      type: 'bar',
      height: 350,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '40%',
        borderRadius: 4,
        distributed: false,
        groups: 2,
        colors: {
          ranges: [
            {
              from: Number.NEGATIVE_INFINITY,
              to: 0,
              strokeWidth: 1,
              strokeColor: '#961D14',
              fillColor: '#C0483F',
            },
            {
              from: 0,
              to: Number.POSITIVE_INFINITY,
              strokeWidth: 1,
              strokeColor: '#47873D',
              fillColor: '#71B167',
            },
          ],
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 1,
      colors: ['#47873D', '#961D14'],
    },
    xaxis: {
      categories: categories || ['N/A', 'N/A', 'N/A'],
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        style: {
          colors: '#A0AEC0',
          fontSize: '14px',
        },
      },
    },
    yaxis: {
      labels: {
        formatter: value => shortenLargeNumbers(value, true),
        style: {
          colors: '#A0AEC0',
          fontSize: '12px',
        },
      },
    },
    colors: ['#71B167', '#C0483F'],
    legend: {
      show: false,
    },
    fill: {
      opacity: 1,
    },
    grid: {
      borderColor: '#f1f1f1',
      strokeDashArray: 4,
      yaxis: {
        lines: {
          show: true,
        },
      },
      xaxis: {
        lines: {
          show: false,
        },
      },
    },
    states: {
      hover: {
        filter: {
          type: 'none',
        },
      },
    },
  };

  return (
    <div className="w-full h-[400px]">
      {loading ? (
        <Loader height={25} />
      ) : (
        <ReactApexChart
          options={options}
          series={series}
          type="bar"
          height="100%"
        />
      )}
    </div>
  );
};

export default OverviewChart;
